import { toSentence } from 'Data/format'

export function getLocationNames(locations) {
  return toSentence(locations.map(item => item.location.name))
}
